// extracted by mini-css-extract-plugin
export default {"link":"NavLink_link__e7zkv","active":"NavLink_active__PWDxY","number":"NavLink_number__0caX1","title":"NavLink_title__9QMzZ"};